module.exports = __webpack_public_path__ + "static/img/process-2.358da2d9.png";